<template lang="pug">
  div.without-tabs
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
      slot
        e-form(:formValidator="formValidator")
          div.body
            div.col
              e-form-group(
                name="capacity"
                label="S - средняя производительность принятого в расчетах транспортного средства по вывозу"
                :model="fields"
                tabView="tab1"
                validationRule="double"
              )

              e-form-group(
                name="zero_run"
                label="L0 - средний нулевой пробег, приходящегося на 1 рейс"
                :model="fields"
                tabView="tab1"
                validationRule="double"
              )

              e-form-group(
                name="loading_time"
                label="Н погр-разгр - нормативная продолжительность погрузки-разгрузки, включая маневрирование, час"
                :model="fields"
                tabView="tab1"
                validationRule="double"
              )

              e-form-group(
                name="fuel_price"
                label="Ц - планируемая среднерыночная цена за единицу топлива"
                :model="fields"
                tabView="tab1"
                validationRule="double"
              )

              e-form-group(
                name="transport_price"
                label="Стр - среднерыночная цена транспорта"
                :model="fields"
                tabView="tab1"
                validationRule="double"
              )

              e-form-group(
                name="transport_work"
                label="Гч - годовое число часов работы транспортного средства "
                :model="fields"
                tabView="tab1"
                validationRule="double"
              )

              e-form-group(
                name="amortization_rate"
                label="Н - норма амиортизационных отчислений %"
                :model="fields"
                tabView="tab1"
                validationRule="double"
              )

              e-form-group(
                name="fuel_consumption"
                label="Q - норма расхода топлива"
                :model="fields"
                tabView="tab1"
                validationRule="double"
              )

</template>

<script>
  import formBaseMixin from '../../components/form/form-base-mixin.js'
  import {calculation} from "../../api/api-endpoints"

  export default {
    mixins: [formBaseMixin],
    /**
     * @override
     */
    title () {
      return this.formTitle
    },
    computed: {
      /**
       * @override
       */
      itemId () {
        return 'global'
      },
      /**
       * @override
       */
      formTitle () {
        return 'Настройки региона'
      }
    },
    methods: {
      /**
       * @override
       */
      getSuccessTitle () {
        return null
      },
      getItemEndpoint () {
        return calculation.locationTariffSetting()
      },
      getUpdateOrCreateUrl() {
        return calculation.locationTariffSettingUpdate()
      }
    }
  }
</script>
